import { KaskoService } from '../services/kaskoService';

// actions types

export const FETCH_REGIONS_REQUEST = 'FETCH_REGIONS_REQUEST';
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS';
export const FETCH_REGIONS_FAILURE = 'FETCH_REGIONS_FAILURE';

// actionCreators

function fetchRegionsRequest() {
  return {
    type: FETCH_REGIONS_REQUEST
  }
}

function fetchRegionsSuccess(regions) {
  return {
    type: FETCH_REGIONS_SUCCESS,
    payload: regions
  }
}

function fetchRegionsFailure(isError) {
  return {
    type: FETCH_REGIONS_FAILURE,
    payload: isError
  }
}

export function fetchRegions() {
  const { getRegions } = new KaskoService();

  return function (dispatch) {
    dispatch(fetchRegionsRequest());
    getRegions()
      .then((response) => {
        localStorage.setItem('regions', JSON.stringify(response.data));
        dispatch(fetchRegionsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchRegionsFailure(true));
      })
  }
}
